<div class="card-images-container">
  <ng-content select="[slot=images-content]"></ng-content>
  <div class="badges">
    <ng-content select="[slot=images-badges]"></ng-content>
  </div>
</div>
